import styles from "./ForgotPasswordPage.module.css"
import Navbar from "../../components/Navbar/NavbarOnboarding/Navbar";
import ForgotPasswordForm from "./components/ForgotPasswordForm/ForgotPasswordForm";
import { useTranslation } from "react-i18next";
/**
* Forgot password page.
* Contains form for changing password.
* @returns TSX.Element
*/
const ForgotPasswordPage = () => {
    const { t } = useTranslation(); // Translation
    return(
        <>
            <Navbar/>
            <div className={styles.Page}>
                <div className={styles.ForgotPasswordBlock}>
                    <div className={styles.ForgotPasswordTitle}>
                        {t("forgot_password.title")}
                    </div>
                    <ForgotPasswordForm/>
                </div>
            </div>
        </>
    )
};

export default ForgotPasswordPage;
